import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDeadlinesSelected = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7 2C7.5523 2 8 2.4477 8 3V4H16V3C16 2.4477 16.4477 2 17 2C17.5523 2 18 2.4477 18 3V4H19C20.1046 4 21 4.8954 21 6V20C21 21.1046 20.1046 22 19 22H5C3.8954 22 3 21.1046 3 20V6C3 4.8954 3.8954 4 5 4H6V3C6 2.4477 6.4477 2 7 2ZM5 9V20H19V9H5Z",
		fill: "#3DCCCC"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M9.5 14.5L11 16L15 12",
		stroke: "#3DCCCC",
		strokeWidth: 1.6,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgDeadlinesSelected;
